import { Link } from "@remix-run/react";
import { AuthAwareLink } from "~/components/ui/AuthAwareLink";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 pt-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and description */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center">
              <img
                src="/logo-light.png"
                alt="Slowdive"
                className="h-12 w-auto mr-2 opacity-60 dark:hidden"
              />
              <img
                src="/logo-dark.png"
                alt="Slowdive"
                className="h-12 w-auto mr-2 opacity-60 hidden dark:block"
              />
              {/* <span className="text-xl font-bold text-gray-900">slowdive</span> */}
            </Link>
            <p className="mt-4 text-gray-600 dark:text-gray-300 text-sm">
              저속노화를 위한 맞춤 레시피 서비스. 건강한 식단으로 더 나은 삶을
              만들어보세요.
            </p>
          </div>

          {/* Quick links */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white tracking-wider uppercase">
              바로가기
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="/recipes"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  레시피 찾기
                </Link>
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  건강정보
                </Link>
              </li>
              <li>
                <AuthAwareLink
                  to="/shopping"
                  requiresAuth={true}
                  authMessage="장보기 기능을 사용하려면 로그인이 필요합니다."
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  장보기
                </AuthAwareLink>
              </li>
              <li>
                <AuthAwareLink
                  to="/recommendations"
                  requiresAuth={true}
                  authMessage="맞춤형 추천을 받으려면 로그인이 필요합니다."
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  맞춤형 추천
                </AuthAwareLink>
              </li>
              <li>
                <AuthAwareLink
                  to="/favorites"
                  requiresAuth={true}
                  authMessage="즐겨찾기를 확인하려면 로그인이 필요합니다."
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  즐겨찾기
                </AuthAwareLink>
              </li>
            </ul>
          </div>

          {/* Contact and legal */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white tracking-wider uppercase">
              고객 지원
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  서비스 소개
                </Link>
              </li>
              {/*  <li>
                <Link
                  to="/contact"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  문의하기
                </Link>
              </li> */}
              <li>
                <Link
                  to="/privacy"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  개인정보보호정책
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-base text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
                >
                  이용약관
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 border-t border-gray-200 dark:border-gray-700 pt-6">
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
            &copy; {currentYear} slowdive. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
